module.exports = __webpack_public_path__ + "img/a1b2c3d4-7052-8579-f6fc-0a000160ef13.fa9f1ecb.png";